<div [formGroup]="parentForm" class="select-field multiselect-field" style="{{ minWidth ? 'min-width:' +minWidth : ''}}">
  <mat-select [formControlName]="controlName" multiple [placeholder]="inputPlaceholder" (selectionChange)="onValueChanged($event)"
              (openedChange)="onOpenedChange($event)" (mousedown)="onTriggerInteraction()" (keydown)="onTriggerInteraction()" (blur)="onBlur()"
              panelClass="visits-designated-contacts">
    <mat-option *ngFor="let item of visibleItems" [value]="item.value">{{item.text}}</mat-option>
  </mat-select>
</div>
